module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAhCAYAAADZPosTAAAABHNCSVQICAgIfAhkiAAAAJRJREFUSIntzjEKwkAURdH7haA7srMIWZsbiKux0SogKVyMActn42AYkszADFb/lq84PJMk6nXZVcQAcNBBBx100MF/g09gqgWOwAnoctAUOAKtmU1m9shBt8AhYGHIQdfAAejmWC66BAbsvfZiC43BewpLovp1k7RPQXGSjpJeX6OnBFtAeyRdS7AIPSOpKcVm6OEDkZRjORIRB/AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/FO/resources/img/ribbon.png
// module id = 328
// module chunks = 0